import React from 'react';

function getEmbedUrl(url) {
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]+)/);
  if (yt) return { tipo: 'iframe', src: `https://www.youtube.com/embed/${yt[1]}` };
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return { tipo: 'iframe', src: `https://player.vimeo.com/video/${vimeo[1]}` };
  return { tipo: 'video', src: url };
}

// url: link de YouTube/Vimeo o archivo .mp4/.webm directo
export default function VideoSection({ url, caption }) {
  if (!url) return null;
  const embed = getEmbedUrl(url);

  return (
    <div style={{ padding: '14px 22px 30px' }}>
      {caption && (
        <div style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--forest)', marginBottom: 10 }}>{caption}</div>
      )}
      <div style={{ width: '100%', borderRadius: 'var(--r-lg)', overflow: 'hidden', aspectRatio: '16/9', background: '#000' }}>
        {embed.tipo === 'iframe' ? (
          <iframe src={embed.src} title={caption || 'Video'} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen style={{ width: '100%', height: '100%', border: 'none' }} />
        ) : (
          <video src={embed.src} controls style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
      </div>
    </div>
  );
}
